import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { ACCOUNTS_QUERY_KEY } from "./useAccounts";

type AccountResponse = components["schemas"]["AccountResponse"];

export type RestoreAccountVariables = {
  accountId: string;
};

export function useRestoreAccount() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<AccountResponse, Error, RestoreAccountVariables>({
    mutationFn: async ({ accountId }) => {
      const { data, error } = await client.POST("/api/accounts/{account_id}/restore", {
        params: { path: { account_id: accountId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to restore account ${accountId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}
